import { PaginationResponseBase } from '../interfaces/ApiResponses';
import {
  ApiResponse,
  IDonViPdfExtra,
  IHopDongResponseBase,
} from '@/core/interfaces/ApiResponses';
import { apiServiceInstance } from '@/core/helpers/utils';
import type {
  HopDongCreateRequest,
  HopDongUpdateRequest,
} from '@/types/hop-dong';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export class HopDongService {
  static fetchContractDetail(id: number): Promise<{
    data: ApiResponse<IHopDongResponseBase>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      `/api/v1/hop-dong/chi-tiet/${id}`
    );
  }

  static async listAll({
    searchTerm = '',
    hopDongType = -1,
    per_page = 200,
  }: {
    searchTerm?: string;
    hopDongType?: number;
    per_page?: number;
  } = {}): Promise<{
    items: IHopDongResponseBase[];
    extra?: IDonViPdfExtra;
  }> {
    const allItems: IHopDongResponseBase[] = [];
    let page = 1;
    let total = Infinity;
    let extra: IDonViPdfExtra | undefined;

    while (allItems.length < total) {
      const { data: response } = await HopDongService.fetchAllContracts({
        current_page: page,
        per_page,
        searchTerm,
        hopDongType,
      });
      const {
        data: { data, total: totalItems },
      } = response;

      if (page === 1) {
        extra = response.extra as IDonViPdfExtra | undefined;
      }

      total = totalItems;
      allItems.push(...data);

      if (!data.length) break;
      page += 1;
    }

    return { items: allItems, extra };
  }

  static fetchAllContracts({
    current_page,
    per_page,
    searchTerm,
    hopDongType,
  }: {
    current_page?: number;
    per_page?: number;
    searchTerm?: string;
    hopDongType?: number;
  }): Promise<{
    data: ApiResponse<PaginationResponseBase<IHopDongResponseBase>>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      '/api/v1/hop-dong/danh-sach',
      {
        params: {
          page: current_page ?? 1,
          ...(searchTerm && {
            s: searchTerm,
          }),
          ...(typeof hopDongType !== 'undefined' &&
            hopDongType !== -1 && {
              loai_hop_dong: hopDongType,
            }),
        },
        headers: {
          perpage: per_page ?? 200,
        },
      }
    );
  }

  /** POST /tao-moi — unified create `{ hopDong, hdvt }` */
  static create(payload: HopDongCreateRequest): Promise<{
    data: ApiResponse<IHopDongResponseBase>;
  }> {
    return apiServiceInstance().vueInstance.axios.post(
      '/api/v1/hop-dong/tao-moi',
      payload,
      { headers: JSON_HEADERS }
    );
  }

  /** POST /cap-nhat/{id} — unified update `{ hopDong, hdvt }` */
  static update(
    contractId: number,
    payload: HopDongUpdateRequest
  ): Promise<{
    data: ApiResponse<IHopDongResponseBase>;
  }> {
    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/hop-dong/cap-nhat/${contractId}`,
      payload,
      { headers: JSON_HEADERS }
    );
  }

  static delete(id: number) {
    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/hop-dong/xoa/${id}`
    );
  }
}
